import axios from "axios";
import qs from "querystring";

import RedirectService from "../redirect-service";
import ToastService from "../../service/toast-service";
import { SERVER_BASE_URL } from "../../config";

class AuthManager {
  toasty = (data) => {
    const { error, info, redirect } = data;
    if (error) ToastService.errorToast(error);
    if (info) ToastService.infoToast(info);
    if (redirect) RedirectService.redirect(redirect);
  };

  constructor() {
    this.stateManager = null;
    this.state = {
      isLoggedIn: false,
      username: "",
      profile: {},
    };
  }

  register(stateManager) {
    this.stateManager = stateManager;
  }

  setProfile = (profile) => {
    if (profile && this.stateManager) {
      this.state.username = profile.username;
      this.state.profile = profile;
      this.stateManager({
        isLoggedIn: true,
        username: profile.username,
        profile: profile,
      });
    }
  };

  profile = async () => {
    const url = `${SERVER_BASE_URL}/auth`;
    console.log("making request to ", url);
    const { data } = await axios.get(url, { withCredentials: true });
    console.log("got data as ", data);
    this.toasty(data);
    const { payload: Profile } = data;
    this.setProfile(Profile);
    return Profile;
  };

  logout = async () => {
    const url = `${SERVER_BASE_URL}/auth/logout`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.toasty(data);
    const { payload } = data;
    if (this.stateManager && payload)
      this.stateManager({ isLoggedIn: false, profile: {}, username: "" });
    return payload;
  };

  guestSignup = async ({ username, password, confirm }) => {
    const url = `${SERVER_BASE_URL}/auth/guest/signup?${qs.stringify({
      username,
      password,
      confirm,
    })}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.toasty(data);
    const { payload } = data;
    return payload;
  };

  guestLogin = async ({ username, password }) => {
    const url = `${SERVER_BASE_URL}/auth/guest/login?${qs.stringify({
      username,
      password,
    })}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.toasty(data);
    const { payload: profile } = data;
    this.setProfile(profile);
    return profile && true;
  };

  googleSignup = async ({ email, name, imageUrl, googleUserId, username }) => {
    const url = `${SERVER_BASE_URL}/auth/google/signup?${qs.stringify({
      email,
      googleUserId,
      username,
      name,
      imageUrl,
    })}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.toasty(data);
    const { payload } = data;
    return payload;
  };

  googleLogin = async ({ email, googleUserId }) => {
    const url = `${SERVER_BASE_URL}/auth/google/login?${qs.stringify({
      email,
      googleUserId,
    })}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.toasty(data);
    const { payload: profile } = data;
    this.setProfile(profile);
    return profile && true;
  };

  connectGoogle = async ({ email, name, imageUrl, googleUserId }) => {
    const url = `${SERVER_BASE_URL}/auth/google/connect?${qs.stringify({
      email,
      googleUserId,
      name,
      imageUrl,
    })}`;
    const { data } = await axios.get(url, { withCredentials: true });
    this.toasty(data);
    const { payload: profile } = data;
    this.setProfile(profile);
    return profile && true;
  };

  currentUser = async (details) => {
    const url = `${SERVER_BASE_URL}/auth`;
    const {
      data: { payload: user, info },
    } = await axios.get(url, { withCredentials: true });

    if (info) ToastService.infoToast(info);

    if (user) {
      const { username, email } = user;
      if (this.stateManager)
        this.stateManager({ isLoggedIn: true, username, email });
    }

    return true;
  };

  login = async (details) => {
    const url = `${SERVER_BASE_URL}/auth/email/login?${qs.stringify(details)}`;
    const {
      data: { payload: user, error, info },
    } = await axios.get(url, { withCredentials: true });
    if (error) {
      ToastService.errorToast(error);
      return false;
    }
    if (info) ToastService.infoToast(info);

    if (user) {
      const { username, email } = user;
      if (this.stateManager)
        this.stateManager({ isLoggedIn: true, username, email });
    }

    return true;
  };

  signup = async (details) => {
    const url = `${SERVER_BASE_URL}/auth/email/signup?${qs.stringify(details)}`;
    const {
      data: { error, info },
    } = await axios.get(url, { withCredentials: true });

    if (error) {
      ToastService.errorToast(error);
      return false;
    }

    if (info) ToastService.infoToast(info);

    return true;
  };

  verifyOTP = async (details) => {
    const url = `${SERVER_BASE_URL}/auth/email/otp?${qs.stringify(details)}`;
    const {
      data: { error, info },
    } = await axios.get(url, { withCredentials: true });

    if (error) {
      ToastService.errorToast(error);
      return false;
    }

    if (info) ToastService.infoToast(info);

    return true;
  };
}

const instance = new AuthManager();

export default instance;
